import React from 'react';
import Button from 'commonComponents/Button/Button';
import HeadersWithContentAndImage from 'commonComponents/sections/HeadersWithContentAndImage/HeadersWithContentAndImage';
import OverviewImage from 'oldAssets/images/static_pages/career/overview-photo.webp';

const WorkAtWA = ({ title, subtitle, text, button }) => {
  const clickHandle = () => {
    const jobs = document.querySelector('#openPositions');
    jobs.scrollIntoView({ behavior: 'smooth' });
  };

  const textContent = (
    <>
      <p>{ text }</p>
      <Button label={ button } type="narrow"
        onClick={ clickHandle }
      />
    </>
  );

  const sectionProps = { title, subtitle, textContent };

  return (
    <HeadersWithContentAndImage
      { ...sectionProps }
      image={ OverviewImage }
      anchor='work-at-wa'
    />    
  );
};

export default WorkAtWA;
